import React, { useState } from 'react';
import ProjectCard from "./ProjectsCard"
import data_projects from "./projects.data"



const Projects = () => {
    const [projects, setProjects] = useState(data_projects)
    const[curName, setCurName] = useState('all');

    const handleFilterCategory = (name) => {
        setCurName(name);
        if (name == 'all') {
            setProjects(data_projects);
        } else {
            const new_array = data_projects.filter(project => project.category.includes(name));
            setProjects(new_array);
        }
    }
    return (
        <div className="card-inner animated" id="works-card">
            <div className="card-wrap">
                <div className="container projects">
                    <div className="content resume">

                        <div className="title">Projects</div>


                        <div className="row">
                            <div className="projects__navbar">
                                <div onClick={() => handleFilterCategory('all')} className={curName == 'all' ? 'projects__navbar-active ':''}>All</div>
                                <div onClick={() => handleFilterCategory('react.js')} className={curName == 'react.js' ? 'projects__navbar-active ' : ''}>React</div>
                                <div onClick={() => handleFilterCategory('mongoDB')} className={curName == 'mongoDB' ? 'projects__navbar-active ' : ''}>MongoDB</div>
                                <div onClick={() => handleFilterCategory('node.js')} className={curName == 'node.js' ? 'projects__navbar-active ' : ''}>Node</div>
                                <div onClick={() => handleFilterCategory('vanilla')} className={curName == 'vanilla' ? 'projects__navbar-active ' : ''}>Vanilla</div>
                            </div>
                            <div className="row">

                                {
                                    projects.map(project =>
                                        <ProjectCard key={project.name} project={project} />)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;